import { createSlice } from "@reduxjs/toolkit";

const meditationEditSlice = createSlice({
  name: "meditationEdit",
  initialState: {
    isMeditationEditOpen: false,
  },
  reducers: {
    toogleMeditationEdit: (state) => {
      state.isMeditationEditOpen = !state.isMeditationEditOpen;
    },
  },
});

export const { toogleMeditationEdit } = meditationEditSlice.actions;
export default meditationEditSlice.reducer;